import cleanUpResponse from '@/util/cleanUpResponse';

export default async function GetDeliveryScheduleInfoForMFDRelocationForm(data) {
  const response = await $.soap({
    body: {
      GetDeliveryScheduleForMFDRelocationForm: {
        $xmlns: 'http://dla.mil/ems/bpm/order/customer_order_delivery_schedule',
        OrderId: data.orderId
      }
    },
    blueprintArrays: ['GetDeliveryScheduleForMFDRelocationFormResponse.DeliverySchedule.OF_MFDRelocation'],
    blueprint: {
      schedule: [
        'GetDeliveryScheduleForMFDRelocationFormResponse.DeliverySchedule.OF_MFDRelocation',
        {
          deviceMake: '$.DeviceMake',
          deviceModel: '$.ModelNumber',
          fromBase: '$.FromBase',
          fromOrgUnit: '$.FromOrgUnit',
          fromAddress: {
            id: '$.FromAddressID',
            addressLine1: '$.FromAddress1',
            addressLine2: '$.FromAddress2',
            buildingFloorNumber: '$.FromBuildingFloorNumber',
            floorNumber: '$.FromFloorNumber',
            roomNumber: '$.FromRoomNumber',
            poleNumber: '$.FromPoleNumber',
            suite: '$.FromSuite',
            roomPoleNumber: '$.FromRoomPoleNumber',
            city: '$.FromCity',
            regionId: '$.FromRegionID',
            zip: '$.FromZip',
            regionCode: '$.FromRegionCode',
            regionName: '$.FromRegionName',
            isConus: '$.FromIsConus',
            organization: '$.FromOrgUnit',
            base: '$.FromBase'
          },
          fromAddressId: '$.FromAddressID',
          fromDeliveryPOC: {
            deliveryPOCFirstName: '$.FromDeliveryPOCFirstName',
            deliveryPOCLastName: '$.FromDeliveryPOCLastName',
            deliveryPOCEmail: '$.FromDeliveryPOCEmail',
            deliveryPOCPhone: '$.FromDeliveryPOCPhone'
          },
          fromITPOC: {
            itPOCFirstName: '$.FromITPOCFirstName',
            itPOCLastName: '$.FromITPOCLastName',
            itPOCEmail: '$.FromITPOCEmail',
            itPOCPhone: '$.FromITPOCPhone'
          },
          fromStandardPocId: '$.FromDeliveryPOCID',
          fromItPocId: '$.FromITPOCID',
          toBase: '$.ToBase',
          toOrgUnit: '$.ToOrgUnit',
          toAddress: {
            id: '$.ToAddressID',
            addressLine1: '$.ToAddress1',
            addressLine2: '$.ToAddress2',
            buildingFloorNumber: '$.ToBuildingFloorNumber',
            floorNumber: '$.ToFloorNumber',
            roomNumber: '$.ToRoomNumber',
            poleNumber: '$.ToPoleNumber',
            suite: '$.ToSuite',
            roomPoleNumber: '$.ToRoomPoleNumber',
            city: '$.ToCity',
            regionId: '$.ToRegionID',
            zip: '$.ToZip',
            regionCode: '$.ToRegionCode',
            regionName: '$.ToRegionName',
            isConus: '$.ToIsConus',
            base: '$.ToBase',
            organization: '$.ToOrgUnit'
          },
          toAddressId: '$.ToAddressID',
          toDeliveryPOC: {
            deliveryPOCFirstName: '$.ToDeliveryPOCFirstName',
            deliveryPOCLastName: '$.ToDeliveryPOCLastName',
            deliveryPOCEmail: '$.ToDeliveryPOCEmail',
            deliveryPOCPhone: '$.ToDeliveryPOCPhone'
          },
          toITPOC: {
            itPOCFirstName: '$.ToITPOCFirstName',
            itPOCLastName: '$.ToITPOCLastName',
            itPOCEmail: '$.ToITPOCEmail',
            itPOCPhone: '$.ToITPOCPhone'
          },
          toStandardPocId: '$.ToDeliveryPOCID',
          toItPocId: '$.ToITPOCID'
        }
      ]
    }
  });

  cleanUpResponse(response);

  response.schedule[0].fromDeliveryPOCName = response.schedule[0].fromDeliveryPOC?.deliveryPOCFirstName
    ? `${response.schedule[0].fromDeliveryPOC.deliveryPOCFirstName} ${response.schedule[0].fromDeliveryPOC.deliveryPOCLastName}`
    : null;
  response.schedule[0].fromITPOCName = response.schedule[0].fromITPOC?.itPOCFirstName
    ? `${response.schedule[0].fromITPOC.itPOCFirstName} ${response.schedule[0].fromITPOC.itPOCLastName}`
    : null;
  response.schedule[0].toDeliveryPOCName = response.schedule[0].toDeliveryPOC?.deliveryPOCFirstName
    ? `${response.schedule[0].toDeliveryPOC.deliveryPOCFirstName} ${response.schedule[0].toDeliveryPOC.deliveryPOCLastName}`
    : null;
  response.schedule[0].toITPOCName = response.schedule[0].toITPOC?.itPOCFirstName
    ? `${response.schedule[0].toITPOC.itPOCFirstName} ${response.schedule[0].toITPOC.itPOCLastName}`
    : null;

  return response.schedule;
}
